import { createElement, Fragment, JSX } from 'react';

/**
 * Page copy that comes from SSR page data — owner 2026-10-11: one source of truth for page / SEO copy is
 * xconvert-web-ssr (sources/page-data-overrides/<slug>.json). `page_seo.title` / `page_seo.description` are the H1
 * and the paragraph under it (PageSeo contract); designed pages keep the rest of their copy in `page_content`.
 * Fields named `*Html` are inline HTML authored in that repo (links, <code>, <span>); every other field is plain
 * text. Components keep only UI microcopy (buttons, labels, inputs).
 */
export interface PageCopy {
    seo: { title?: string; description?: string };
    content: any;
}

export function pageCopy(props: any): PageCopy {
    return { seo: props?.pageData?.page_seo || {}, content: props?.pageData?.page_content || {} };
}

/** Inline HTML from SSR page data, rendered as the element `as` (default <p>). */
export function RichText({ as = 'p', html, className }: { as?: keyof JSX.IntrinsicElements; html?: string; className?: string }) {
    if (!html) return null;
    return createElement(as, { className, dangerouslySetInnerHTML: { __html: html } });
}

/** Plain text whose '\n' are line breaks (a two-line H1); `last` wraps the last line of a multi-line text. */
export function Lines({ text, last }: { text?: string; last?: (line: string) => JSX.Element }) {
    const lines = (text || '').split('\n');
    return <>{lines.map((line, i) => <Fragment key={i}>
        {i > 0 && <br />}
        {last && lines.length > 1 && i === lines.length - 1 ? last(line) : line}
    </Fragment>)}</>;
}
